import React, { Component } from "react";
import { Input, Row, Col, message, Button, Divider, } from "antd";
import { PictureUpload, DictRadio, Form, Panel, Modal } from "@/nano";
import { context } from "@/nano";
import { queryUmsUserById, updateById, } from "./personalSetting.service";
import UpdatePassword from "./updatePassword";
import "./personalSetting.less";

export default class PersonalSetting extends Component {

  state = {
    loading: false,
    data: {},
    updatePasswordModel: {
      open: false,
    },
    //changeAvatarFlag: true,
  };

  formRef = React.createRef();
  formRef_2 = React.createRef();

  constructor(props) {
    super(props)
    if (["view", "update", "create"].includes(props.type)) {
      if ("create" === this.props.type) {
        // 新增页面默认启用
        // this.state.data = {
        //   ...this.state.data,
        //   enabled: 1
        // };
      } else {
        // this.state.data = {
        //   ...this.state.data,
        //   ...props.data,
        // };
      }
    }
  };

  /**
   * 组件挂载
   */
  componentDidMount() {
    this.loadUserInfo();
  };

  loadUserInfo = () => {
    // console.log(context.getId());
    // console.log(context.getName());
    // console.log(context.getUsername());
    // console.log(context.getUser());
    // console.log(context.getPosition());
    // console.log(context.getOrganization());
    queryUmsUserById({ id: context.getId() }).then(res => {
      this.setState({
        ...this.state,
        data: {
          ...res.data,
          organization: context.getOrganization().name, // 所属机构
          position: context.getPosition().name,  // 岗位
        },
      });
    });
  };

  onUpdatePassword = () => {
    this.setState({
      ...this.state,
      updatePasswordModel: {
        open: true,
        type: "update",
        data: {
          userId: this.state.data.id ? this.state.data.id : context.getId(),
          //password: this.state.data.password,
        }
      }
    });
  };

  // onChangeAvatar = () => {
  //   this.setState({
  //     ...this.state,
  //     changeAvatarFlag: false,
  //     data: {
  //       ...this.state.data,
  //       avatar: "",
  //     }
  //   });
  // };

  // onAvatar = (info, index) => {
  //   updateAvatar({ id: context.getId(), avatar: info, }).then(res => {
  //     if (res.code === "200") {
  //       message.info("修改头像成功");
  //     } else {
  //       message.info("修改头像失败");
  //     }
  //   });
  // };

  onCancel = () => {
    this.props.onCancel && this.props.onCancel();
  };

  onConfirm = () => {
    this.formRef.current.submit();
    this.props.onConfirm && this.props.onConfirm();
  };

  onSubmit = (values) => {
    if ("update" === this.props.type) {
        const personalData = {
          ...values,
          id: context.getId(),
        };
        updateById(personalData).then(res => {
          message.success(res.message);
          this.onCancel();
          //this.props.onAfterSubmit && this.props.onAfterSubmit()
        });
    } else {
      //   save(values).then(res => {
      //     message.success(res.message);
      //     this.onCancel();
      //     this.props.onAfterSubmit && this.props.onAfterSubmit()
      //   }).catch(res => {

      //   });
    }
  };

  onUpdatePersonalInfo = () => {
    const personalData = {
      id: context.getId(),
    };
    updateById(personalData).then(res => {
      message.success(res.message);
      this.onCancel();
      // this.props.onAfterSubmit && this.props.onAfterSubmit()
    });
  };

  onCancelUpdatePassword = () => {
    this.setState({
      ...this.state,
      updatePasswordModel: {
        ...this.state.updatePasswordModel,
        open: false,
      }
    });
  };

  onUpdatePasswordSubmit = (newPassword) => {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        password: newPassword,
      },
    });
  }

  render() {
    const { updatePasswordModel, } = this.state;
    return (
      <Panel>
        <Panel.Info>
          <Form
            ref={this.formRef}
            data={this.state.data}
            onFinish={this.onSubmit}
            disabled={"view" === this.props.type}
          >
            <Divider orientation="left">个人信息</Divider>
            {/* <Row>
                <Col span={6}>
                    <Form.Item
                    name="avatar"
                    label="头像"
                    >
                    <PictureUpload width={110} height={110} accept=".jpeg,.png" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                  <Button type="link" onClick={this.onChangeAvatar} disabled={false} >更换</Button>
                </Col>
                <Col span={12}>

                </Col>
            </Row> */}
            <Row className="row-border-top">
              <Col span={12}>
                <Form.Item
                  name="name"
                  label="真实姓名"
                  rules={[
                    {
                      required: true,
                      message: "请输入",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="avatar"
                  label="头像"
                >
                  {/* <PictureUpload width={150} height={150} disabled={changeAvatarFlag} onChange={this.onAvatar} /> */}
                  <PictureUpload width={150} height={150} />
                </Form.Item>
              </Col>
              {/* <Col span={5}>
                <Button type="link" onClick={this.onChangeAvatar} disabled={false} >更换</Button>
              </Col> */}
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="cardNo"
                  label="身份证号"
                  rules={[
                    {
                      required: true,
                      message: "请输入",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="sex"
                  label="性别"
                >
                  <DictRadio
                    dict="sys_sex"
                    parse="number"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              {/* <Col span={24} align="center"><Button type="primary" onClick={this.onUpdatePersonalInfo}>保存</Button></Col> */}
              <Col span={24} align="center"><Button type="primary" onClick={this.onConfirm}>保存</Button></Col>
            </Row>
          </Form>
          
          <Form
            ref={this.formRef_2}
            data={this.state.data}
            disabled={"update" === this.props.type}
          >
            <Divider orientation="left">账户信息</Divider>
            <Row className="row-border-top">
              <Col span={12}>
                <Form.Item
                  name="username"
                  label="登录账号"
                  rules={[
                    {
                      required: false,
                      message: "请输入",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item
                  name="password"
                  label="登录密码"
                  rules={[
                    {
                      required: false,
                      message: "请输入",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="input password"
                  />
                </Form.Item>

              </Col>
              <Col span={2}><Button type="link" onClick={this.onUpdatePassword} disabled={false} style={{width:'100%',height:'100%'}}>修改</Button></Col>
            </Row>

            <Divider orientation="left">岗位信息</Divider>
            <Row className="row-border-top">
              <Col span={12}>
                <Form.Item
                  name="organization"
                  label="所属"
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="position"
                  label="岗位"
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

          </Form>

          {updatePasswordModel.open && (
            <Modal
              title="修改密码"
              width={430}
              open={true}
              onCancel={this.onCancelUpdatePassword}
            >
              <UpdatePassword {...updatePasswordModel} onCancel={this.onCancelUpdatePassword} onAfterSubmit={this.onUpdatePasswordSubmit} />
            </Modal>
          )}
        </Panel.Info>

        {/* <Panel.Footer>
          <Panel.Footer.ButtonBar
            actions={[
              {
                type: "cancel",
                onClick: this.onCancel,
                loading: this.state.loading,
              },
              {
                type: "confirm",
                onClick: this.onConfirm,
                loading: this.state.loading,
                visible: ["create", "update"].includes(this.props.type),
              },
            ]}
          />
        </Panel.Footer> */}

      </Panel>
    );
  };

};
